import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import { connect, useDispatch, useSelector } from "react-redux";
import { addMemberships } from "../../redux/action/Memberships";
import { ManageServiceList } from "../../redux/action/services";
import { Formik } from "formik";
import NoImage from "../../assets/images/noimages.jpg";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ValidationAddMembership } from "../../utills/Validation";
import { APIURL } from "../../redux/action/config";
import Select from "react-select";

// import SunEditor from "suneditor-react";
// import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
const initialState = { alt: "", src: "" };

const AddMembership = ({ initialContent = "" }) => {
  const [activeLoader, setActiveLoader] = useState(false);

  // const [content, setContent] = useState(initialContent);
  const [{ alt, src }, setPreview] = useState(initialState);
  const [img, setImg] = useState();

  const fileHandler = (event) => {
    const { files } = event.target;
    var formdata = new FormData();
    formdata.append("image", event.target.files[0]);

    const token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/image`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log('result', result);
        if (result.status == "success") {
          setActiveLoader(false);
          setImg(result.data.images.image);
        }
      })
      .catch((error) => console.log("error", error));
    setPreview(
      files.length
        ? {
          src: URL.createObjectURL(files[0]),
          alt: files[0].name,
        }
        : initialState
    );
    setActiveLoader(true);
  };

  // const [servicId, setServices] = useState([]);
  // const counts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  // const onChange = (event) => {
  //   const isChecked = event.target.checked;
  //   if (isChecked) {
  //     setServices([...servicId, event.target.value]);
  //   }
  // };
  const resetForms = () => {
    document.getElementById("myForm").reset();
  };
  /* memberList */
  const dispatch = useDispatch();
  const memberList = useSelector((state) => state.manageservice.list);
  useEffect(() => {
    dispatch(ManageServiceList());
  }, [dispatch]);
  // const serviceData = memberList?.data?.allServices
  //   ? memberList?.data?.service?.filter((item) => item.parentId == 0)
  //   : "";

  const serviceData = memberList?.data?.shortedServices
    ? memberList?.data?.shortedServices
    : "";

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "rgba(248, 246, 242, 0.3)",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused ? "#f8f6f2" : isSelected ? "#fff" : undefined,
      zIndex: 1,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };

  const serviceOptions = serviceData
    ? serviceData?.map((item) => {
      return {
        value: item?.id,
        label: item?.name,
      };
    })
    : "";
  const [servicId, setServices] = useState("");
  const handleSelect = (e) => {
    setServices([...e]);
  };
  const [serviceMsg, setServiceMsg] = useState(false);

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Add New Membership" page="addMembership">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <div className="card-title">
                      <span className="svg-icon svg-icon-1 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                            fill="black"
                          ></path>
                          <path
                            opacity="0.3"
                            d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      <h2>Add New Membership</h2>
                    </div>
                  </div>
                  <div className="card-body pt-5">
                    <Formik
                      initialValues={{
                        name: "",
                        service_id: servicId,
                        order_Counts: "",
                        additionalDriversPrice: "",
                        price: "",
                        vehicleLimit: "",
                        vehiclePrice: "",
                        additionalDrivers: "",
                        motorcyclePrice: "",
                        motorcycleAtvPrice: "",
                        bicyclePrice: "",
                        description: "",
                        image: "",
                        car: "",
                        carPrice: "",
                        priceMonthly: "",
                        priceDaily: "",
                        price1to7Days: "",
                        price7to30Days: "",
                        waitingPeriod: "",
                        firstTimeDiscount: 0,
                        golfCartPrice: ""
                      }}
                      validationSchema={ValidationAddMembership}
                      onSubmit={(values) => {
                        const serviceIds = servicId
                          ? servicId?.map((item) => item.value)
                          : [];
                        const payload = {
                          ...values,
                          service_id: serviceIds,
                        };
                        // // values.description = content;
                        values.image = img;
                        console.log('valuesvalues', values);
                        if (!payload?.service_id?.length > 0) {
                          setServiceMsg("Service is required");
                          return;
                        }
                        setServiceMsg("");
                        dispatch(addMemberships(payload));
                        // addMemberships(values, { service_id: servicId })
                        // resetForms();
                      }}
                    >
                      {({
                        values,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        errors,
                        touched,
                      }) => (
                        <form
                          className="form"
                          id="myForm"
                          onSubmit={handleSubmit}
                        >
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Membership Badge
                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div
                                className="image-input w-125px h-125px image-input-outline"
                                data-kt-image-input="true"
                                style={{
                                  backgroundImage: `url(${src ? src : NoImage})`,
                                }}
                              >
                                <label
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                  data-kt-image-input-action="change"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Change avatar"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                  </svg>
                                  <input
                                    id="file-input"
                                    accept="image/*"
                                    type="file"
                                    onChange={fileHandler}
                                  />
                                  <input type="hidden" name="avatar_remove" />
                                </label>
                                <span
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                  data-kt-image-input-action="cancel"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Cancel avatar"
                                >
                                  <i className="bi bi-x fs-2"></i>
                                </span>
                                {activeLoader == true ? (
                                  <div
                                    className="d-flex align-items-center justify-content-center h-100"
                                    style={{ background: "#e2e2e270" }}
                                  >
                                    <div
                                      className="spinner-border w-80"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="form-text">
                                Allowed file types: png, jpg, jpeg.
                              </div>
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                <span className="required">Membership Name</span>
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="name"
                                id="name"
                                defaultValue={values.name}
                              />
                              {errors.name && touched.name ? (
                                <div className="text-danger mt-2">
                                  {errors.name}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Membership Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <div className="row">
                                <div className="col-4">
                                  <label for="price" className="mb-3">
                                    <b>Yearly Price</b>
                                  </label>
                                  <input
                                    type="number"
                                    step="any"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="price"
                                    id="price"
                                    defaultValue={values.price}
                                  />
                                </div>
                                <div className="col-4">
                                  <label for="monthly" className="mb-3">
                                    <b> Monthly Price</b>
                                  </label>

                                  <input
                                    type="number"
                                    step="any"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="priceMonthly"
                                    id="priceMonthly"
                                    defaultValue={values.priceMonthly}
                                  />
                                </div>
                                <div className="col-4">
                                  <label for="priceDaily" className="mb-3">
                                    <b> Daily Price</b>
                                  </label>

                                  <input
                                    type="number"
                                    step="any"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="priceDaily"
                                    id="priceDaily"
                                    defaultValue={values.priceDaily}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Rental Duration Pricing
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <div className="row">
                                <div className="col-4">
                                  <label for="price1to7Days" className="mb-3">
                                    <b>1-7 Day Price</b>
                                  </label>

                                  <input
                                    type="number"
                                    step="any"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="price1to7Days"
                                    id="price1to7Days"
                                    defaultValue={values.price1to7Days}
                                  />
                                </div>
                                <div className="col-4">
                                  <label for="price7to30Days" className="mb-3">
                                    <b>7-30 Day Price</b>
                                  </label>

                                  <input
                                    type="number"
                                    step="any"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="price7to30Days"
                                    id="price7to30Days"
                                    defaultValue={values.price7to30Days}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                First Time Discount
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <div className="row">
                                <div className="col-4">
                                  <label for="firstTimeDiscount" className="mb-3">
                                    <b>Discount Price</b>
                                  </label>
                                  <input
                                    type="number"
                                    step="any"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="firstTimeDiscount"
                                    id="firstTimeDiscount"
                                    defaultValue={values.firstTimeDiscount}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*  */}
                          {/* <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Membership Yearly Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="priceYearly"
                                id="priceYearly"
                                defaultValue={values.priceYearly}
                              />
                              {errors.priceYearly && touched.priceYearly ? (
                                <div className="text-danger mt-2">
                                  {errors.priceYearly}
                                </div>
                              ) : null}
                            </div>
                          </div> */}
                          {/* <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Membership Monthly Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="priceMonthly"
                                id="priceMonthly"
                                defaultValue={values.priceMonthly}
                              />
                            </div>
                          </div> */}
                          {/* <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Membership Daily Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="priceDaily"
                                id="priceDaily"
                                defaultValue={values.priceDaily}
                              />
                            </div>
                          </div> */}
                          {/*  */}
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                <span className="required">Allowed Orders</span>
                              </div>
                            </div>
                            <div className="membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="order_Counts"
                                id="order_Counts"
                                defaultValue={values.order_Counts}
                              />
                              {errors.order_Counts && touched.order_Counts ? (
                                <div className="text-danger mt-2">
                                  {errors.order_Counts}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          {/* <div className="membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                              {serviceData?.length ? (
                                serviceData?.map((item, index) => {
                                  return (
                                    <div
                                      className="form-check form-check-custom form-check-solid form-check-sm"
                                      key={index}
                                    >
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="service_id"
                                        id={item.id}
                                        defaultValue={item.id}
                                        onChange={onChange}
                                      />
                                      <label className="ms-2" htmlFor={item.id}>
                                        {item.name}
                                      </label>
                                    </div>
                                  );
                                })
                              ) : (
                                <p
                                  style={{
                                    margin: "14px 22px",
                                    color: "#ff4e00",
                                  }}
                                >
                                  Please add services first
                                </p>
                              )}
                              {errors.name && touched.name ? (
                                <div className="text-danger mt-2">
                                  {errors.name}
                                </div>
                              ) : null}
                            </div> */}
                          {/* <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Vehicle Name
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="car"
                                id="car"
                                defaultValue={values.car}
                              />
                              {errors.car && touched.car ? (
                                <div className="text-danger mt-2">
                                  {errors.car}
                                </div>
                              ) : null}
                            </div>
                          </div> */}
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Car Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="vehiclePrice"
                                id="vehicle-price"
                                defaultValue={values.vehiclePrice}
                              />
                            </div>
                          </div>

                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Motorcycle/ATV Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="motorcyclePrice"
                                id="motorcyclePrice"
                                defaultValue={values.motorcyclePrice}
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Golf Cart Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="golfCartPrice"
                                id="golfCartPrice"
                                defaultValue={values.golfCartPrice}
                              />
                            </div>
                          </div>
                          {/* <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Motorcycle Atv Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="motorcycle atv price"
                                name="motorcycleAtvPrice"
                                id="motorcycleAtvPrice"
                                defaultValue={values.motorcycleAtvPrice}
                              />
                            </div>
                          </div> */}
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Bicycle Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="bicyclePrice"
                                id="bicyclePrice"
                                defaultValue={values.bicyclePrice}
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Vehicle Limit under Price
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="vehicleLimit"
                                id="vehicleLimit"
                                defaultValue={values.vehicleLimit}
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                No. of Dependent users allowed
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="additionalDrivers"
                                id="additionalDrivers"
                                defaultValue={values.additionalDrivers}
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Price for adding Dependent user
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="additionalDriversPrice"
                                id="additionalDriversPrice"
                                defaultValue={values.additionalDriversPrice}
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Waiting Period
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                className="form-control form-control-solid"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="waitingPeriod"
                                id="waitingPeriod"
                                defaultValue={values.waitingPeriod}
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3 ">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                <span className="required">Select Services</span>
                              </div>
                            </div>
                            <div className="select-service-field membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                              <Select
                                name="service_id"
                                closeMenuOnSelect={false}
                                options={serviceOptions}
                                onChange={handleSelect}
                                isMulti
                                styles={colourStyles}
                                placeholder="Select services"
                              />
                              {!serviceMsg == false && (
                                <p className="text-danger">{serviceMsg}</p>
                              )}
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Description
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <textarea
                                className="form-control form-control-solid"
                                rows="3"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="description"
                                id="description"
                                defaultValue={values.description}
                              ></textarea>
                              {/* <SunEditor
                                autoFocus={true}
                                width="100%"
                                height="150px"
                                setOptions={{
                                  buttonList: [
                                    // default
                                    ["undo", "redo"],
                                    ["bold", "underline", "italic", "list"],
                                    ["table", "link", "image"],
                                    ["fullScreen"],
                                  ],
                                }}
                                setContents={initialContent}
                                onChange={setContent}
                              /> */}
                              {/* <div>{content}</div> */}
                            </div>
                          </div>
                          <div className="separator mb-6"></div>
                          <div className="d-flex justify-content-end">
                            <Link
                              to="/manage-membership"
                              type="reset"
                              className="btn btn-light me-3"
                            >
                              Cancel
                            </Link>
                            <button type="submit" className="btn btn-primary">
                              <span className="indicator-label">Save</span>
                            </button>
                          </div>
                          <div></div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};
export default connect(null, { addMemberships, ManageServiceList })(
  AddMembership
);
